import { getCurrentAge } from "../../functions";
import { strategyOptions, LIFE_EXP, RETIRE_AGE, CONTRIBUTION, } from "../../constants";
export const editAssumtionsSelector = ({ graphReducer, }) => ({
    sliderOptions: graphReducer.sliderOptions,
    openingBalance: graphReducer.openingBalance,
    strategyIndex: graphReducer.strategyIndex,
    expense_home: graphReducer.expense_home,
    socialSecurity: graphReducer.socialSecurity,
});
export const homeScreenSelector = ({ graphReducer, userReducer, }) => ({
    assets: graphReducer.graph.assets,
    retirementAssests: graphReducer.graph.results.retirementAssests,
    userData: userReducer.userData,
    token: userReducer.token,
});
export const thumbsUpSelector = ({ graphReducer, userReducer }) => {
    const { strategyIndex, sliderOptions } = graphReducer;
    const r_before = getStrategyBefore(strategyIndex);
    const r_after = getStrategyAfter(strategyIndex);
    const currentAge = getCurrentAge(userReducer.userData?.dob || "1991-01-01");
    let lifeExpVal = LIFE_EXP.VALUE;
    let retireAgeVal = RETIRE_AGE.VALUE;
    let contributionVal = CONTRIBUTION.VALUE;
    if (sliderOptions) {
        const { lifeExp, retireAge, contribution } = sliderOptions;
        lifeExpVal = +lifeExp.value;
        retireAgeVal = +retireAge.value;
        contributionVal = +contribution.value;
    }
    const earnYears = retireAgeVal - currentAge;
    const retireYears = lifeExpVal - retireAgeVal - 1;
    const r_n_before = r_before ** earnYears;
    const r_n_after = r_after ** (retireYears - 1);
    // Max values
    const r_before_max = getStrategyBefore(3);
    const r_after_max = getStrategyAfter(3);
    const r_n_before_max = r_before_max ** earnYears;
    const r_n_after_max = r_after_max ** (retireYears - 1);
    return {
        openingBalance: graphReducer.openingBalance,
        strategyIndex: graphReducer.strategyIndex,
        expense_home: graphReducer.expense_home,
        contributionVal,
        currentAge,
        r_before,
        r_before_max,
        r_after,
        r_after_max,
        r_n_before,
        r_n_before_max,
        r_n_after,
        r_n_after_max,
        earnYears,
        retireYears,
        retireAgeVal,
        lifeExpVal,
    };
};
const getStrategyBefore = (index) => {
    return strategyOptions[index]?.value + 1;
};
const getStrategyAfter = (index) => {
    return strategyOptions[index ? index - 1 : index]?.value + 1;
};
